/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=028f2b4a&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=028f2b4a&scoped=true&lang=less"

import exportComponent from "D:\\work\\官网\\bfb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028f2b4a"]])

export default __exports__